export const TIMERS = {
    serverTimeMark: 'serverTimeMark',
    currentTimeMeasure: 'currentTimeMeasure',
    sessionTimeMeasure: 'sessionTimeMeasure',
    hours: 18,
    minutes: 0,
    seconds: 0
};
